// Lactate thresholds (mmol/L)
export const HIGH_LACTATE_ALERT_VALUES = [
  1.5, 2.0, 2.5, 3.0, 3.5, 4.0, 4.5, 5.0, 5.5, 6.0,
] as const;

export const HIGH_LACTATE_ALERT_ITEMS = [
  { label: '1.5 mmol/L', value: 1.5 },
  { label: '2.0 mmol/L', value: 2.0 },
  { label: '2.5 mmol/L', value: 2.5 },
  { label: '3.0 mmol/L', value: 3.0 },
  { label: '3.5 mmol/L', value: 3.5 },
  { label: '4.0 mmol/L', value: 4.0 },
  { label: '4.5 mmol/L', value: 4.5 },
  { label: '5.0 mmol/L', value: 5.0 },
  { label: '5.5 mmol/L', value: 5.5 },
  { label: '6.0 mmol/L', value: 6.0 },
] as const;

// Duration (minutes)
export const HIGH_LACTATE_ALERT_DURATION_VALUES = [30, 60, 90, 120] as const;

export const HIGH_LACTATE_ALERT_DURATION_ITEMS = [
  { label: '0.5 hour', value: 30 },
  { label: '1.0 hour', value: 60 },
  { label: '1.5 hours', value: 90 },
  { label: '2.0 hours', value: 120 },
] as const;

const HIGH_LACTATE_ALERT_DEFAULT_VALUE = 2.0 as const; // mmol/L
const HIGH_LACTATE_ALERT_DURATION_DEFAULT_VALUE = 60 as const; // minutes

export const PATIENT_ALERT_DEFAULT_VALUES = {
  displayLactateData: true,
  highLactateAlert: true,
  highLactateAlertAbove: HIGH_LACTATE_ALERT_DEFAULT_VALUE,
  highLactateAlertDuration: HIGH_LACTATE_ALERT_DURATION_DEFAULT_VALUE,
};
